import "../App.css";
import { ValidationSchemaLogin } from "../Containers/Login";
import React from "react";

function isTokenValid(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

function Admin() {
  React.useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token && isTokenValid(token)) {
      window.location.href = "/time";
    }
  }, []);

  return (
    <div className="App ds-admin-login-shell">
      <ValidationSchemaLogin />
    </div>
  );
}

export default Admin;
